/**
 * @typedef {object} PersonaTerms
 * @property {string} singular - 'Medewerker' (FIXtool) or 'Deelnemer' (all other hosts)
 * @property {string} plural - 'Medewerkers' or 'Deelnemers'
 * @property {string} singularLower - Lowercase singular, for use mid-sentence
 * @property {string} pluralLower - Lowercase plural, for use mid-sentence
 */

/**
 * Resolves how personas are named in the UI for a given white-label host.
 * FIXtool calls them 'Medewerkers'; every other host calls them 'Deelnemers'.
 *
 * @param {string | undefined} hostName - Host name from the Hostname hook ('' while loading)
 * @returns {PersonaTerms}
 */
const getPersonaTerms = (hostName) => {
    const isFixtool = hostName === 'FIXtool';

    return {
        singular: isFixtool ? 'Medewerker' : 'Deelnemer',
        plural: isFixtool ? 'Medewerkers' : 'Deelnemers',
        singularLower: isFixtool ? 'medewerker' : 'deelnemer',
        pluralLower: isFixtool ? 'medewerkers' : 'deelnemers',
    };
};

export default getPersonaTerms;
